import React from 'react';
import { Badge, Form } from 'antd';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import './style.scss';

interface IProps {
  name: string;
  label?: string;
  className?: string;
  children: React.ReactElement;
  required?: boolean;
  help?: FieldError;
  noStyle?: boolean;
}

export const Field: React.FC<IProps> = ({
  name,
  label,
  className,
  children,
  required,
  help,
  noStyle,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = help || (errors[name as any] as FieldError);

  return (
    <Form.Item
      label={
        label && (
          <span className='flex items-center'>
            {label}
            {required && <Badge status='error' className='ml-2' />}
          </span>
        )
      }
      validateStatus={error ? 'error' : ''}
      help={error ? error.message : null}
      rootClassName={clsx('c-field', className)}
      noStyle={noStyle}
    >
      <Controller
        name={name!}
        control={control}
        render={({ field }) => {
          const elementType = children.type;
          return React.createElement(elementType, {
            ...field,
            ...children.props,
          });
        }}
      />
    </Form.Item>
  );
};
